import { combineReducers } from 'redux'
import monthlyEventsReducer from './metabolicStat/reducers'
import mskReducer from './msk/reducers'
import recentAlertsReducer from './recentAlerts/reducers'
import { ClinicalState } from '../../../../types/clinical'

export default combineReducers<ClinicalState>({
	metabolicStat: monthlyEventsReducer,
	msk: mskReducer,
	recentAlerts: recentAlertsReducer,
})
